import React, { useState, useEffect, useContext } from 'react';
import { Box, Stack, TextField, Typography, Tabs, Tab } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import { TabPanel, a11yProps } from '../shared/components/tabPanel';
import { FormMode } from '../utils/extensions/constantEx';
import { AddressFormInitalState } from '../utils/hooks/useNurseForm';
import { NurseFormContext } from '../utils/contexts/nurseFormContext';

const NurseContact = (props) => {
    const { formOpenMode, expanded, handleAccordionChange } = props;
    const { nurseFormValue, selectedNurseJosn, SetNurseFormValue } = useContext(NurseFormContext);

    const [selectedContactTabIndex, setSelectedContactTabIndex] = useState(0);
    const [firstContactName, setFirstContactName] = useState('');
    const [firstContactMobileNo, setFirstContactMobileNo] = useState('');
    const [firstContactPhoneNo, setFirstContactPhoneNo] = useState('');
    const [firstContactAddress, setFirstContactAddress] = useState('');
    const [secondContactName, setSecondContactName] = useState('');
    const [secondContactMobileNo, setSecondContactMobileNo] = useState('');
    const [secondContactPhoneNo, setSecondContactPhoneNo] = useState('');
    const [secondContactAddress, setSecondContactAddress] = useState('');
    const [firstContactId, setFirstContactId] = useState(-1);
    const [secondContactId, setSecondContactId] = useState(-2);
    const [firstContactAddressId, setFirstContactAddressId] = useState(0);
    const [secondContactAddressId, setSecondContactAddressId] = useState(0);

    useEffect(() => {
        let tempFirstContactId = -1;
        let tempFirstContactName = '';
        let tempFirstContactMobileNo = '';
        let tempFirstContactPhoneNo = '';
        let tempFirstContactAddress = '';
        let tempFirstContactAddressId = 0;

        let tempSecondContactId = -1;
        let tempSecondContactName = '';
        let tempSecondContactMobileNo = '';
        let tempSecondContactPhoneNo = '';
        let tempSecondContactAddress = '';
        let tempSecondContactAddressId = 0;

        if ((formOpenMode === FormMode.ViewMode || formOpenMode === FormMode.EditMode) && selectedNurseJosn && selectedNurseJosn.id > 0 && selectedNurseJosn.contacts && selectedNurseJosn.contacts.length > 0) {
            let tempContact;
            if (selectedNurseJosn.contacts[0]) {
                tempContact = { ...selectedNurseJosn.contacts[0] };
                tempFirstContactId = tempContact.id;
                tempFirstContactName = tempContact.contact_name ?? '';
                tempFirstContactMobileNo = tempContact.phone1 ?? '';
                tempFirstContactPhoneNo = tempContact.phone2 ?? '';

                if (tempContact.address) {
                    tempFirstContactAddressId = tempContact.address.id;
                    tempFirstContactAddress = tempContact.address.address ?? '';
                }
            }
            if (selectedNurseJosn.contacts.length > 1 && selectedNurseJosn.contacts[1]) {
                tempContact = { ...selectedNurseJosn.contacts[1] };
                tempSecondContactId = tempContact.id;
                tempSecondContactName = tempContact.contact_name ?? '';
                tempSecondContactMobileNo = tempContact.phone1 ?? '';
                tempSecondContactPhoneNo = tempContact.phone2 ?? '';

                if (tempContact.address) {
                    tempSecondContactAddressId = tempContact.address.id;
                    tempSecondContactAddress = tempContact.address.address ?? '';
                }
            }
        }
        setFirstContactId(tempFirstContactId);
        setFirstContactName(tempFirstContactName);
        setFirstContactMobileNo(tempFirstContactMobileNo);
        setFirstContactPhoneNo(tempFirstContactPhoneNo);
        setFirstContactAddress(tempFirstContactAddress);
        setFirstContactAddressId(tempFirstContactAddressId);

        setSecondContactId(tempSecondContactId);
        setSecondContactName(tempSecondContactName);
        setSecondContactMobileNo(tempSecondContactMobileNo);
        setSecondContactPhoneNo(tempSecondContactPhoneNo);
        setSecondContactAddress(tempSecondContactAddress);
        setSecondContactAddressId(tempSecondContactAddressId);
    }, [formOpenMode, selectedNurseJosn]);

    useEffect(() => {
        handleContactChange();
    }, [firstContactName, firstContactMobileNo, firstContactPhoneNo, firstContactAddress,
        secondContactName, secondContactMobileNo, secondContactPhoneNo, secondContactAddress
    ]);

    const handleContactTabChange = (event, newValue) => {
        setSelectedContactTabIndex(newValue);
    };

    const handleContactChange = () => {
        const tempContacts = [];
        let tempContact = null;

        if (firstContactName.trim().length > 0 || firstContactMobileNo.trim().length > 0) {
            tempContact = {
                id: firstContactId,
                name: firstContactName,
                phoneNo1: firstContactMobileNo,
                phoneNo2: firstContactPhoneNo,
                address: null
            };
            setAddressModel(tempContact, firstContactAddressId, firstContactAddress);
            tempContacts.push(tempContact);
        }
        if (secondContactName.trim().length > 0 || secondContactMobileNo.trim().length > 0) {
            tempContact = {
                id: secondContactId,
                name: secondContactName,
                phoneNo1: secondContactMobileNo,
                phoneNo2: secondContactPhoneNo,
                address: null
            };
            setAddressModel(tempContact, secondContactAddressId, secondContactAddress);
            tempContacts.push(tempContact);
        }
        SetNurseFormValue({ ...nurseFormValue, contacts: [...tempContacts] });
    }

    const setAddressModel = (tempContact, id, addressText) => {
        const tempAddress = { ...AddressFormInitalState };
        if (id > 0 || addressText.trim().length > 0) {
            tempAddress.id = id;
            tempAddress.address = addressText.trim();
        }
        tempContact.address = tempAddress;
    }

    return (

        <Accordion expanded={expanded === 'panelContacts'} onChange={handleAccordionChange('panelContacts')}>
            <AccordionSummary id="panel-contacts">
                <Typography>Contacts</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={selectedContactTabIndex} onChange={handleContactTabChange}>
                            <Tab label="First Contact" {...a11yProps(0)} />
                            <Tab label="Second Contact" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedContactTabIndex} index={0}>
                        <Stack spacing={1}>
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <TextField size="small" fullWidth
                                        label="Name"
                                        value={firstContactName}
                                        onChange={(event) => {
                                            setFirstContactName(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField size="small" fullWidth
                                        label="Mobile No"
                                        value={firstContactMobileNo}
                                        onChange={(event) => {
                                            setFirstContactMobileNo(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField size="small" fullWidth
                                        label="Phone No"
                                        value={firstContactPhoneNo}
                                        onChange={(event) => {
                                            setFirstContactPhoneNo(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <TextField size="small" fullWidth multiline
                                        label="Address"
                                        rows={4}
                                        value={firstContactAddress}
                                        onChange={(event) => {
                                            setFirstContactAddress(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </TabPanel>
                    <TabPanel value={selectedContactTabIndex} index={1}>
                        <Stack spacing={1}>
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <TextField size="small" fullWidth
                                        label="Name"
                                        value={secondContactName}
                                        onChange={(event) => {
                                            setSecondContactName(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField size="small" fullWidth
                                        label="Mobile No"
                                        value={secondContactMobileNo}
                                        onChange={(event) => {
                                            setSecondContactMobileNo(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <TextField size="small" fullWidth
                                        label="Phone No"
                                        value={secondContactPhoneNo}
                                        onChange={(event) => {
                                            setSecondContactPhoneNo(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <TextField size="small" fullWidth multiline
                                        label="Address"
                                        rows={4}
                                        value={secondContactAddress}
                                        onChange={(event) => {
                                            setSecondContactAddress(event.target.value);
                                        }}
                                        slotProps={{
                                            input: {
                                                readOnly: formOpenMode === FormMode.ViewMode
                                            },
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </TabPanel>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}

export default NurseContact;
